<template>
    <section>
        <div class="row" v-if="auth_user.ambiente === 'A'">
            <div class="col-md-6">
                <div class="form-group">
                    <label>Módulo</label>
                    <select v-model="modulo.fk_modulo_id" class="form-control">
                        <option :value="null">{{$t('words.select')}}</option>
                        <option v-for="item in modulos" :key="item.id" :value="item.id">
                            {{item.nome}} - {{(item.valor)}}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Quantidade</label>
                    <div class="input-group">
                        <input class="form-control" v-numericOnly v-model="modulo.quantidade">
                        <span class="input-group-btn">
                            <button @click="addModulo()" :disabled="!modulo.fk_modulo_id" class="btn btn-success">
                                <i class="fa fa-plus"></i>
                                {{$t('words.add')}}
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div v-for="(item, i) in plano.modulos" :key="i" class="col-md-4 col-sm-6">
                <div class="form-group">
                    <label>{{item.nome}}</label>
                    <div :class="{'input-group': auth_user.ambiente === 'A'}">
                        <input v-model="item.quantidade" :disabled="auth_user.ambiente !== 'A'" v-numericOnly
                            class="form-control" placeholder="Insira a quantidade, deixe em branco">
                        <span v-if="auth_user.ambiente === 'A'" class="input-group-btn">
                            <button @click="removeModulo(i)" class="btn btn-danger"><i class="fa fa-trash"></i></button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            plano: {}
        },
        data() {
            return {
                modulo: {
                    nome: null,
                    descricao: null,
                    quantidade: 1,
                    fk_modulo_id: null,
                },
            }
        },
        computed: {
            modulos() {
                return this.$store.state.planoModulo.select;
            },
            user() {
                return this.$store.state.user;
            }
        },
        methods: {
            addModulo() {
                let mod = this.modulos.find(x => x.id == this.modulo.fk_modulo_id)
                if (this.plano.modulos.findIndex(m => m.fk_modulo_id == mod.id) > -1) {
                    return;
                }
                this.modulo.nome = mod.nome;
                this.modulo.descricao = mod.descricao;
                this.plano.modulos.push(_.clone(this.modulo));
                this.modulo = {
                    nome: null,
                    descricao: null,
                    quantidade: 1,
                    fk_modulo_id: null,
                }
            },
            removeModulo(i) {
                this.plano.modulos.splice(i, 1);
            }
        }
    }
</script>